import { Alert, IconButton, Typography } from '@mui/joy';
import { AlertTriangle, X } from 'lucide-react';

export enum WarningType {
  True = 'true',
  False = 'false'
}

type WarningDndProps = {
  setShowWarning: (warning: WarningType) => void;
};

const WarningDnd = ({ setShowWarning }: WarningDndProps) => {
  const handleWarning = () => {
    setShowWarning(WarningType.False);
    localStorage.setItem('showWarning', WarningType.False);
  };

  return (
    <Alert
      color="warning"
      endDecorator={
        <IconButton color="warning" onClick={handleWarning} variant="soft">
          <X size={20} />
        </IconButton>
      }
      startDecorator={<AlertTriangle size={20} />}
      sx={{
        alignItems: 'flex-start',
        borderRadius: 0,
        position: 'absolute',
        width: 'auto%',
        top: '70px',
        zIndex: 100
      }}
      variant="soft"
    >
      <div>
        <div>Warning</div>
        <Typography color="warning" level="body-sm">
          Transition accepts only one statement (And, Or, Not, Condition) at the
          root. You can drag and drop inside a statement. The Not statement
          can't have more than one statement.
        </Typography>
      </div>
    </Alert>
  );
};

export default WarningDnd;
